const swissMarketsOverrides = {
  palette: {
    mode: 'light',
    secondary: {
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#EE242C',
    },
    green: {
      color: '#1DCD9A',
    },
    lightblue: {
      color: '#E8F7FE',
    },
    yellow: {
      color: '#FF9F00',
    },
    red: {
      color: '#EE242C',
    },
    grey: {
      color: 'rgba(0,0,0,0.75)',
    },
  },
}

export default swissMarketsOverrides
